"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const computePrice_1 = require("../computePrice");
const utils_1 = require("../utils");
const lodash_findindex_1 = __importDefault(require("lodash.findindex"));
/**
 * removes MODIFIER from an order item.
 * Can only be done when the order is in IN_PROGRESS or in CREATED status
 * @param event of type RemoveModifierEvent
 * @param prevState
 */
function default_1(event, prevState = {}) {
    let order = prevState;
    if (!(0, utils_1.isOrderEditable)(order.status)) {
        return order;
    }
    order.orderItems = order.orderItems || [];
    const orderItem = order.orderItems.find(_orderItem => _orderItem.id === event.orderItemId);
    if (orderItem === undefined) {
        return order;
    }
    orderItem.modifiers = orderItem.modifiers || [];
    // if UnitPrice provided to lookup the modifier, because same modifier but different price
    const modifierIndex = (0, lodash_findindex_1.default)(orderItem.modifiers, e => {
        return (e.id === event.modifierId &&
            e.modifierGroupId === event.modifierGroupId &&
            ((event === null || event === void 0 ? void 0 : event.unitPrice) === undefined || (event === null || event === void 0 ? void 0 : event.unitPrice) === e.unitPrice));
    });
    if (modifierIndex >= 0) {
        // remove modifier
        orderItem.modifiers.splice(modifierIndex, 1);
        order = { ...order, ...(0, computePrice_1.computeOrderTotals)(order) };
    }
    return order;
}
exports.default = default_1;
//# sourceMappingURL=removeModifier.js.map